import React from 'react';
import { categoryConfigurations } from './categoryConfig';

// Create base map from explicit configurations (only entries with valid emojis/images)
const baseMap: Record<string, React.ReactNode | string> = Object.fromEntries(
  categoryConfigurations
    .filter((config) => config.imageSource || config.emoji) // Only include configs with valid emoji/image
    .map((config) => [
      config.key,
      config.imageSource ? (
        <img
          src={config.imageSource}
          alt={config.imageAlt}
          style={{ width: '1em', height: '1em', lineHeight: '1em' }}
        />
      ) : (
        config.emoji
      ),
    ])
);

// Enhanced map with hierarchical fallback
export const categoryEmojiMap: Record<string, React.ReactNode | string> =
  new Proxy(baseMap, {
    get(target, prop) {
      const key = prop as string;

      // Return if we have an explicit mapping
      if (key in target) {
        return target[key];
      }

      // Try parent categories by removing segments from right to left
      const segments = key.split('.');
      while (segments.length > 1) {
        segments.pop();
        const parentCategory = segments.join('.');
        if (parentCategory in target) {
          return target[parentCategory];
        }
      }

      // Default fallback
      return '❓';
    },
  });
